/**
 * This function compares the mixed results from two different searches.
 * It checks if there are any duplicate results between the two mixed results.
 * It checks the ad content, and quote content. It should compare the id, issuerId, and advertiserName if it exists.
 * @param mixedResults1
 * @param mixedResults2
 * @returns true if there are any duplicate results between the two mixed results
 */
export function hasDuplicateResults(mixedResults1, mixedResults2) {
    if (!mixedResults1 || !mixedResults2) {
        return false;
    }
    for (var _i = 0, mixedResults1_1 = mixedResults1; _i < mixedResults1_1.length; _i++) {
        var result1 = mixedResults1_1[_i];
        for (var _a = 0, mixedResults2_1 = mixedResults2; _a < mixedResults2_1.length; _a++) {
            var result2 = mixedResults2_1[_a];
            // Compare ad content
            if (result1.adContent && result2.adContent) {
                if ((result1.adContent.id &&
                    result1.adContent.id === result2.adContent.id) ||
                    (result1.adContent.issuerId &&
                        result1.adContent.issuerId === result2.adContent.issuerId) ||
                    (result1.adContent.advertiserName &&
                        result1.adContent.advertiserName ===
                            result2.adContent.advertiserName)) {
                    return true;
                }
            }
            // Compare quote content
            if (result1.quoteContent && result2.quoteContent) {
                if ((result1.quoteContent.id &&
                    result1.quoteContent.id === result2.quoteContent.id) ||
                    (result1.quoteContent.issuerId &&
                        result1.quoteContent.issuerId === result2.quoteContent.issuerId)) {
                    return true;
                }
            }
        }
    }
    return false;
}
